const AGGREGATIONS = ['count', 'min', 'max', 'avg', 'sum'].map((a) => a + '(');

export const isAggregateColumn = (column: string) => {
  return AGGREGATIONS.find((aggregation) => column.includes(aggregation));
};
